<template>
  <div class="cangchu_kc">
    <div>
      <div class="headerSearch">
        <div class="sousuo">
          <el-form
            ref="search"
            style="display: flex"
            :model="searchForm"
            label-position="center"
            label-width="100px"
          >
            <el-form-item label="仓储委托单位:">
              <el-select v-model="searchForm.wtDwMc" placeholder="请选择">
                <el-option v-for="(item,index) in wtdwkv" :key="index" :label="item.label" :value="item.value" />
              </el-select>
            </el-form-item>
            <el-form-item label="仓库名称:" style="">
              <el-select v-model="searchForm.ckId" placeholder="请选择">
                <el-option v-for="(item,index) in cfckkv" :key="index" :label="item.label" :value="item.value" />
              </el-select>
            </el-form-item>
            <el-form-item label="化学品:" style="">
              <el-input
                v-model="searchForm.hxpMc"
                placeholder="请输入"
              />
            </el-form-item>

            <el-button
              class="sousuoButton"
              icon="el-icon-search"
              round
              size="small"
              type="primary"
              @click="searchbtn"
            >搜索</el-button>
            <el-button
              size="small"
              class="chongzhiButton"
              icon="el-icon-refresh-right"
              round
              @click="reset"
            >重置</el-button>
          </el-form>
        </div>
      </div>
      <div
        style="
          margin: auto;
          width: 95%;
          max-width: 1518px;
          background-color: white;
          padding-top: 40px;
          padding-bottom: 51px;
        "
      >
        <div class="tablemes">
          <el-table
            ref="cktable"
            v-loading="loading"
            :data="tableData"
            border
            :show-overflow-tooltip="true"
            :header-cell-style="{ background: '#F2F2F2' }"
            style="width: 100%"
          >
            <el-table-column
              v-for="(item, i) in table"
              :key="i"
              :show-overflow-tooltip="true"
              align="center"
              :label="item.label"
            >
              <template slot-scope="scope">
                <span>
                  {{ scope.row[item.key] }}
                </span>
              </template>
            </el-table-column>
          </el-table>

          <el-pagination
            background
            layout="prev, pager,next,jumper,total,sizes"
            :page-sizes="[10, 20, 30, 40]"
            :total="total"
            class="el-page"
            @size-change="pageSize"
            @current-change="currentChange"
          />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
// 获取接口地址
import { getCcKc, homeSelectCk, getccsywtdwMes } from '@/assets/js/common.js'
export default {
  data() {
    return {
      pupopShow: false,
      loading: true,
      searchForm: {
        'wtDwMc': '',
        'ckId': '',
        'hxpMc': ''
      },
      table: [
        {
          key: 'wtDwMc',
          label: '委托单位名称'
        },
        {
          key: 'hxpMc',
          label: '化学品名称'
        },
        {
          key: 'ckMc',
          label: '仓库名称'
        },
        {
          key: 'kclStr',
          label: '库存量'
        }
      ],
      // 库存kv
      cfckkv: [],
      // 委托单位kv
      wtdwkv: [],
      tableData: [], // 表格数据
      total: 0, // 总条数
      currentPage: 1, // 当前页
      pagesize: 10 // 每页的数据条数
    }
  },
  mounted() {
    // 获取列表
    this.getlist()
    // 仓库名称
    this.ckmckvfunc()
    // 仓储委托单位
    this.ccwtdwfunc()
  },
  methods: {
    // 列表
    getlist() {
      getCcKc({
        param: this.searchForm,
        page: this.currentPage,
        size: this.pagesize
      }).then((e) => {
        this.total = e.data.data.total
        this.loading = false
        this.tableData = e.data.data.rows
      })
        .catch(() => {
          this.loading = false
        })
    },
    // 页面信息条数
    pageSize(val) {
      this.pagesize = val
      // 获取列表
      this.getlist()
    },
    // 切换当前页
    currentChange(val) {
      this.currentPage = val
      // 获取列表
      this.getlist()
    },
    // 搜索
    searchbtn() {
      // 获取列表
      this.getlist()
    },
    // 重置
    reset() {
      this.searchForm = this.$options.data().searchForm
      // 获取列表
      this.getlist()
    },
    // 仓库名称
    ckmckvfunc() {
      homeSelectCk()
        .then((e) => {
          this.cfckkv = e.data.data
        })
    },
    // 仓储委托单位
    ccwtdwfunc() {
      getccsywtdwMes()
        .then((e) => {
          this.wtdwkv = e.data.data
        })
    }

  }
}
</script>
<style scoped lang='less'>
.el-table--border {
  z-index: 0;
}
.resetbutton {
  width: 90px;
  height: 39px;
  border-radius: 20px;
}
.cangchu_kc {
  // height: 100%;
  // width: 90%;
  // background-color: white;
  // margin: auto;
  .headerSearch {
    max-width: 1518px;
    width: 95%;
    margin: auto;
    margin-bottom: 11px;
    margin-top: 30px;
    background-color: white;
    padding: 30px 0 20px 0;
    // border: 1px solid red;
    display: flex;
    align-items: center;
    box-shadow: 0px 1px 27px 3px rgba(0, 0, 0, 0.05);
    border-radius: 5px;
    font-size: 15px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #333333;
    .el-form-item {
      margin-bottom: 10px;
      margin-right: 30px;
      &:last-child {
        width: 90px;
        height: 39px;
        /deep/ .el-button {
          width: 90px !important;
          height: 39px;
          border-radius: 3px;
        }
      }
    }
  }
  .sousuo {
    width: 90%;
    margin-left: auto;
    margin-right: auto;
    .sousuoButton {
      width: 90px;
      height: 39px;
      background: #4170ff;
      border-color: #4170ff;
    }
    .chongzhiButton {
      width: 90px;
      height: 39px;
    }
  }
  .tablemes {
    margin: auto;
    width: 90%;
    max-width: 1375px;
    margin-bottom: 57px;
    .el-pagination__total {
      margin-left: 8px;
    }
    .el-pagination {
      padding: 10px 0;

      border: 1px solid #ebeef5;
      border-top: 0;
    }
    .deleteButton {
      background: #ff5721 !important;
      border-color: #ff5721 !important;
    }
    .el-button--warning {
      color: #fff;
      background: #feb800;
      border-radius: 3px;
      border-color: #feb800;
    }
    .el-button--primary {
      color: #fff;
      background: #4170ff;
      border-radius: 3px;
      border-color: #4170ff;
    }
    .el-pager {
      .number {
        background: #4170ff;
        border-color: #4170ff;
      }
    }
  }
}
/deep/.el-pagination.is-background .el-pager li:not(.disabled).active {
  background-color: #4170ff !important;
  color: #fff;
}
</style>
